import script from "./AuthView.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthView.vue?vue&type=script&setup=true&lang=js"

import "./AuthView.vue?vue&type=style&index=0&id=1325cf8e&lang=css"

const __exports__ = script;

export default __exports__